<div
  [ngModelGroup]="modelGroupName"
  #addressRef="ngModelGroup"
  *ngIf="address && !readonly"
  class="address"
>
  <div *ngIf="isManualEntry">
    <div class="formField">
      <nx-ng-textfield
        #address1="ngModel"
        [id]="'addressLineOne-' + id"
        [name]="'address1'"
        [label]="'address_1_label'"
        [placeholder]="'address_1_placeholder'"
        [errorText]="getAddressLine1Error(address1)"
        [isRequired]="true"
        [(ngModel)]="address.address1"
      >
      </nx-ng-textfield>
    </div>

    <div class="formField">
      <nx-ng-textfield
        [id]="'addressLineTwo-' + id"
        [name]="'address2'"
        [label]="'address_2_label'"
        [placeholder]="'address_2_placeholder'"
        [isRequired]="false"
        [(ngModel)]="address.address2"
      >
      </nx-ng-textfield>
    </div>

    <div class="formField">
      <nx-ng-textfield
        #town="ngModel"
        [id]="'townCity-' + id"
        [name]="'town'"
        [label]="'address_town_label'"
        [placeholder]="'address_town_placeholder'"
        [errorText]="getTownError(town)"
        [isRequired]="true"
        [(ngModel)]="address.town"
      >
      </nx-ng-textfield>
    </div>

    <div class="formField postcode">
      <nx-ng-textfield
        #pc="ngModel"
        [id]="'postcode-' + id"
        [name]="'postCode'"
        [label]="'address_postcode_label'"
        [placeholder]="'address_postcode_placeholder'"
        [errorText]="getPostCodeError(pc)"
        [isRequired]="true"
        [(ngModel)]="address.postCode"
        (change)="handleManualPostCodeChange($event)"
      >
      </nx-ng-textfield>
    </div>
    <button
      [id]="'manual-postcode-button-' + id"
      type="button"
      class="address-manual"
      (click)="handlePostcodeEntryClick()"
      *ngIf="isManualEntry"
    >
      {{ 'search_address_using_postcode' | i18next }}
    </button>
  </div>

  <div class="formField postcode" *ngIf="!isManualEntry">
    <nx-ng-postcode
      #postCode="ngModel"
      [id]="'postcode-lookup-' + id"
      [name]="'postCode-lookup'"
      [label]="'address_postcode_label'"
      [placeholder]="'address_postcode_placeholder'"
      [errorText]="getLookupPostCodeError(postCode)"
      [isRequired]="true"
      [addressSearchContext]="addressSearchContext"
      [(ngModel)]="address.postCode"
      (addressSearch)="handleAddressSearch($event)"
      (addressFound)="handleAddressFound($event)"
    >
    </nx-ng-postcode>
    <button
      [id]="'search-postcode-button-' + id"
      type="button"
      class="address-manual"
      (click)="handleManualEntryClick()"
      *ngIf="!isManualEntry"
    >
      {{ 'address_enter_manually' | i18next }}
    </button>
  </div>
</div>
<div class="addressResult" *ngIf="address && readonly">
  <p *ngIf="fullName">
    {{ fullName }}
  </p>
  <p *ngIf="fullName"></p>
  <p *ngIf="address.address1">
    {{ address.address1 }}
  </p>
  <p *ngIf="address.town">
    {{ address.town }}
  </p>
  <p *ngIf="address.postCode">
    {{ address.postCode }}
  </p>
</div>
